<template>
  <div class="wrapper u-text-center">
    <div class="text-block ptb-30 u-text-left" style="font-size: 18px;color:#FFF;">
      {{ hint }}。
    </div>
    <div class="card-wrap">
      <div class="text-block font-large font-red" v-if="!isWxBrowser">小程序 更优体验</div>
      <div v-if="!isWxBrowser">
        <img style="width:200px;margin:50px 0" :src="qrUrl"></img>
        <div style="padding-bottom:20px">点击<span class="copy icon-copy" data-clipboard-text="汽修能手"
                                                 @click="copy">复制</span>小程序名
        </div>
      </div>
      <div v-else class="home">
        <wx-open-launch-weapp
            id="launch-btn"
            :username="username"
            :path="path"
            @launch="handleLaunchFn"
            @error="handleErrorFn"
        >
          <script type="text/wxtag-template">
            <style>
              .we-app-btn {
                line-height: 1.499;
                position: relative;
                display: inline-block;
                font-weight: 400;
                white-space: nowrap;
                border: 1px solid #F5F5F5;
                text-align: center;
                background-image: none;
                cursor: pointer;
                -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
                transition: all .3s cubic-bezier(.645, .045, .355, 1);
                height: 36px;
                padding: 0 30px;
                font-size: 16px;
                border-radius: 999px;
                color: #fff;
                background-color: rgba(0, 213, 11, 0.8);
              }
            </style>
            <button class="we-app-btn">{{ btnText }}</button>
          </script>
        </wx-open-launch-weapp>
        <!--        <button v-else  class="we-app-btn" @click="copy">复制小程序名称【汽修能手】</button>-->
      </div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

import {
  Prepare_Wx_Config
} from "@/api/index";
import ClipboardJS from 'clipboard';
import {Toast} from "vant";

export default {
  data() {
    return {
      company: {},
      qrUrl: 'https://cdn2.carziliao.com/qrcode/202107300050260651211.jpeg',
      username: 'gh_60c2f05ea360', // gh_ 开头的原始小程序ID
      path: 'pages/index/index.html', // 一定要以 .html 结尾
      btnText: "进入维修手册"
    }
  },
  computed: {
    isWxBrowser() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";//此处不能用===
    },
    isIPhone() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.includes('iphone')
    },
    hint() {
      if (this.isWxBrowser) {
        return '新版汽车维修保养手册已经就绪，请点击下方按钮，进入小程序【汽修能手】';
      }
      if (this.$route.query.fr == 'pay') {
        return '请登录小程序购买和支付，请打开微信并搜索小程序【汽修能手】'
      } else {
        return '微信小程序已经开通，小程序登录更方便，请打开微信并搜索小程序【汽修能手】'
      }
    }
  },
  async mounted() {
    this.company = await this.global.getMemberSystem();
    this.path = 'pages/index/index.html?from=h5&companyId=' + this.company.memberSystemId;// 一定要以 .html 结尾
    if (this.isWxBrowser) {
      this.prepareWxConfig();
    }
  },
  methods: {
    prepareWxConfig() {
      try {
        let url = window.location.href.split("#")[0];
        Prepare_Wx_Config({url}).then(res => {
          wx.config({
            debug: false,
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
            ], // 必填，需要使用的JS接口列表
            openTagList: ['wx-open-launch-weapp']  // 微信小程序标签名加入 openTagList
          })
          wx.error(function (res) {
            console.error("微信配置失败", res);
          });
        })
      } catch (e) {
        console.log("设置微信配置失败", e);
      }
    },
    handleLaunchFn(e) {
      console.log(e)
    },
    handleErrorFn(e) {
      console.log('fail', e.detail);
    },

    copy() {
      let clipboard = new ClipboardJS('.icon-copy');

      clipboard.on('success', function (e) {
        console.log('succ', e)
        Toast({
          message: '已复制：“汽修能手”',
          duration: 1000
        })
        clipboard.destroy();
      })
      clipboard.on('error', function (e) {
        Toast({
          message: '复制失败',
          duration: 1000
        })
        clipboard.destroy();
      })
    },
  }
}
</script>

<style scoped>
.card-wrap {
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 8px;

}

.wrapper {
  padding: 40px 40px 0px;
  height: 100vh;
  background-image: linear-gradient(#459bbe, #52d0c8);
}

.home {
  margin: 20px 0;
  min-height: 100vh;
  /*height: 100px;*/
}

.text-block {
  display: block;
}

.font-large {
  font-size: 26px;
  font-weight: 600;
}

.font-red {
  color: red;
}

.p16 {
  padding: 16px;
}

.ptb-30 {
  padding: 30px 0px;
}

.we-app-btn {
  line-height: 1.499;
  position: relative;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  border: 1px solid #F5F5F5;
  text-align: center;
  background-image: none;
  cursor: pointer;
  -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
  transition: all .3s cubic-bezier(.645, .045, .355, 1);
  height: 36px;
  padding: 0 30px;
  font-size: 16px;
  border-radius: 999px;
  color: #fff;
  background-color: rgba(0, 213, 11, 0.8);
}

.copy {
  cursor: pointer;
  /*font-size: 20px;*/
  text-decoration: underline;
  color: #646566;
  padding: 0 5px;
}
</style>
